export { default as CustomerQuotes } from './customerQuotes/customerQuotes'
export { default as DefaultAddress } from './address/DefaultAddress'
export { default as DefaultPayment } from './payment/DefaultPayment'
export { default as PressQuotes } from './pressQuotes/pressQuotes'
export { default as TextCarousel } from './textCarousel/textCarousel'
export { default as MirageMarkdown } from './markdown/markdown'
export { default as ValuePropSection } from './valuePropSection/valuePropSection'
export * from './aboutUs'
export * from './accordion'
export * from './animatedIcons'
export * from './card'
export * from './contentful'
export * from './clotheslineAnimation'
export * from './emailCapture'
export * from './footer'
export * from './header'
export * from './images'
export * from './inputs'
export * from './layout'
export * from './product'
export * from './productTile'
export * from './sections'
export * from './social-media'
export * from './video'
export * from './paymentRequestForm'
export * from './couponCode'
export * from './referralSection'
export * from './confetti'
export * from './giftModal'



// WEBPACK FOOTER //
// ./src/components/index.js